import { BlogNav } from '@gik/blog/components/BlogNav/BlogNav';
import { ShareYourStoryCTA } from '@gik/blog/components/ShareYourStoryCTA/ShareYourStoryCTA';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { SWRConfig } from 'swr';
import { PageLayout } from './PageLayout';

export function withBlogLayout<P>(Component: React.FC<P>): React.FC<P> {
  return (props: P & { fallback? }): React.ReactElement => (
    <SWRConfig value={props?.fallback ? { fallback: props.fallback } : {}}>
      <BlogLayout>
        <Component {...props} />
      </BlogLayout>
    </SWRConfig>
  );
}

export function BlogLayout({ children }) {
  const bem = useBemCN('blog-layout-wrapper');

  return (
    <PageLayout navBarAttachment={<BlogNav />} footerAttachment={<ShareYourStoryCTA />} {...bem()}>
      {children}
    </PageLayout>
  );
}
